module.exports = __webpack_public_path__ + "img/jelly2_thumb.eb5f225d.jpg";